import { createApi } from "@reduxjs/toolkit/query/react";

import type { IGetAiChatMessagesResponse } from "@/providers/store/api/ai-chat/ai-chat.interface";
import type { IApiResponse } from "@/shared/interfaces/api-response.interface";

import customFetchBase from "../custom-fetch-base";

export interface IAdminChatRoomOption {
  id: string;
  name: string;
  districtId: string;
  userId: string;
}

export const adminChatRoomsApi = createApi({
  reducerPath: "adminChatRoomsApi",
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    searchAdminChatRooms: builder.query<
      IAdminChatRoomOption[],
      { search?: string; districtId?: string; userId?: string; limit?: number }
    >({
      query: ({ search, districtId, userId, limit = 10 }) => ({
        url: "/admin/chat-rooms",
        method: "GET",
        params: {
          search: search || undefined,
          districtId: districtId || undefined,
          userId: userId || undefined,
          limit,
        },
      }),
      transformResponse: (result: IApiResponse<{ items: IAdminChatRoomOption[] }>) => result.data.items ?? [],
    }),
    getAdminChatRoom: builder.query<IAdminChatRoomOption, string>({
      query: (roomId) => ({
        url: `/admin/chat-rooms/${roomId}`,
        method: "GET",
      }),
      transformResponse: (result: IApiResponse<IAdminChatRoomOption>) => result.data,
    }),
    getAdminChatRoomMessages: builder.query<
      IGetAiChatMessagesResponse,
      { roomId: string; page?: number; limit?: number }
    >({
      query: ({ roomId, page, limit }) => ({
        url: `/admin/chat-rooms/${roomId}/messages`,
        method: "GET",
        params: {
          page,
          limit,
        },
      }),
      transformResponse: (result: IApiResponse<IGetAiChatMessagesResponse>) => result.data,
    }),
  }),
});

export default adminChatRoomsApi;

export const {
  useSearchAdminChatRoomsQuery,
  useGetAdminChatRoomQuery,
  useGetAdminChatRoomMessagesQuery,
} = adminChatRoomsApi;
